import cSvg from '#themes/default/default/components/svg/svg.js';
import cTooltip from '#themes/default/default/components/tooltip/tooltip.js';

import template from './footer.html' with { type: 'html' };

export default {
	name: 'CFooter',
	components: {
		cSvg,
		cTooltip
	},
	props: {
		isLoading: {
			type: Boolean,
			default: false
		},
		isThankYouPage: {
			type: Boolean,
			default: false
		},
		order: {
			type: Object,
			default: () => null
		},
		page: {
			type: Object,
			default: () => null
		},
		theme: {
			type: Object,
			default: () => null
		},
		url: {
			type: Object,
			default: () => null
		}
	},
	computed: {
		legalResellerStatement() {
			if (this.isThankYouPage && this.url.locale === 'en-in') {
				return this.t('cart_termsNetProphetsReseller');
			}
			return '';
		},
		isRtl() {
			return this.theme.variables.isRtl;
		},
		needHelpTooltip() {
			return this.t('error_helpWithoutId');
		}
	},
	template
};
